import React from 'react';
import { VoidLabelViewStore } from 'modules/order/stores';
import { VoidLabelTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new VoidLabelViewStore(rootStore, componentProps), 'voidLabelViewStore')
class VoidLabel extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <VoidLabelTemplate {...this.props} />;
	}
}

export default VoidLabel;



// WEBPACK FOOTER //
// ./src/modules/order/pages/VoidLabel.jsx